import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Header from "../components/globals/Header";
import SearchBar from "../components/inputs/SearchBar";
import { dummyFaqs } from "../dummyData";
import FAQCard from "../components/cards/FAQCard";
import { useTranslation } from "../languages";

const FAQ = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Container fluid>
        <Header title={"FAQ"} />
        <Row className="mb-4">
          <Col md={7}>
            {/* <SearchBar /> */}
          </Col>
        </Row>
        <Card className="border-none">
          <CardBody className="d-flex flex-row justify-content-center align-items-center">
            <Row className="justify-content-center my-5 g-0">
              <Col md={12} lg={11} xl={9}>
                <Container fluid style={{maxWidth:1200}}>
                  {dummyFaqs?.map((item, at) => {
                    return (
                      <FAQCard
                        answer={t(item?.answer)}
                        index={at + 1}
                        question={t(item?.question)}
                      />
                    );
                  })}
                </Container>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default FAQ;
